import { MAGNOLIA_ROOT_URL } from "./pageUrls";

export const buildPreviewLotsUrl = (
  localSaleLocation: string,
  saleType: string,
  saleDate: string,
  saleLocation?: string
) => {
  const saleChannel = saleLocation?.toLowerCase() === "hybrid" ? "Hybrid" : "e-Auction";
  let url = `${MAGNOLIA_ROOT_URL}/search?q=&bq=salechannel:${saleChannel}`;

  if (localSaleLocation) {
    url += `|salelocation:${localSaleLocation}`;
  }

  if (saleType) {
    url += `|saletype:${saleType}`;
  }

  if (saleDate) {
    url += `|saledate:${saleDate}`;
  }

  return url;
};
